import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { selectActivePresence, selectActivePresenceIsOnQueue, selectAgentSelectablePresences } from 'common/store/genesys-cloud/presence/selectors/presence.selectors';
import { togglePresence, updatePresence } from 'common/store/genesys-cloud/presence/actions/presence.actions';
import { ExtendedPresence, ExtendedPresenceState } from 'common/store/genesys-cloud/presence/models/extended-presence.model';

@Component({
  selector: 'app-genesys-presence-button',
  templateUrl: './genesys-presence-button.component.html',
  styleUrls: ['./genesys-presence-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenesysPresenceButtonComponent {
  @Input()
  isHybrid: boolean;
  readonly PresenceState = ExtendedPresenceState;
  readonly activePresence$ = this.store.select(selectActivePresence);
  readonly presences$ = this.store.select(selectAgentSelectablePresences);
  readonly isOnQueue$ = this.store.select(selectActivePresenceIsOnQueue);
  readonly isLoading$ = this.activePresence$.pipe(map(presence => !presence));

  constructor(private readonly store: Store) {
  }

  changePresence(targetPresence: ExtendedPresence): void {
    this.store.dispatch(updatePresence({ systemPresenceId: targetPresence.id }));
  }

  togglePresence(): void {
    this.store.dispatch(togglePresence());
  }
}
